import {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input';
import { z } from 'zod';

import { emailString, requiredString } from '@/shared/utils/validation';

const validatePhoneNumber = (schema: z.ZodString) => {
  return schema
    .refine(
      isPossiblePhoneNumber,
      'Please specify a valid phone number (include the international prefix).',
    )
    .transform((value) => parsePhoneNumber(value)?.number.toString());
};

export const administratorOnboardingSchema = z.object({
  title: requiredString(),
  jobTitle: requiredString(),
  firstName: requiredString(),
  lastName: requiredString(),
  email: emailString(),
  phoneNumber: validatePhoneNumber(requiredString().min(10).max(20)),
});
